import React, { useState, useEffect } from "react";
import "./boutique-page.css";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { getCategoriesProduitsBoutique, getProduitPrix, getProducts, searchProducts, getCatalogueImage, getQuantiteEnMain } from "../../server/services/catalogue-service";
import Pagination from '../pagination/pagination.js';
import BoutiqueCard from "./boutique-card.js";
import FilterLeftPanel from "./filter-left-panel";
import FacturePanierPopup from "../popups/facture-panier-popup";
import { setSeoTitle } from "../../utils/document";
import LoadingSvg from "../svg/loading.js";
import DemanderProduitPrix from "./demander-produit-prix";
import { getQuantiteTempByIdProduit } from "../../server/services/reservation-service";

function BoutiquePage(props) {
  const history = useHistory();
  const [state, setState] = useState({
    categoriesLoaded: false,
    categories: [],
    items: [],
    // items: allitems.slice(0, 8),
    // pages: Math.ceil(this.props.boutique.catalogue.length / 8),
    // totalItems: allitems.length,
    itemsPerPage: 8,
    currentPage: 1,
    showSortPanel: false,
    isOpen: false,
    refresh: false,
    showPaginationMinimum: false
  });
  const [isPopupProduitPrixOpen, setPopupProduitPrixOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [forceRefresh, setForceRefresh] = useState(false)

  useEffect(async () => {
    setSeoTitle(props.entrepriseName, "Boutique");
    const idFilteredProducts = [];
    getCategoriesProduitsBoutique().then((categories) => {
      const search = decodeURI(history.location.search);
      // let checkboxes = categories;
      let filts = "";
      if (categories.length)
        categories.forEach(el => {
          if (search.includes(el.description)) {
            idFilteredProducts.push(el.idProduitCategorie);
            el['checked'] = true;
            // if (data.category === "Price Range") filts += value.value + ',';
          } else el['checked'] = false;
        })
      setState({
        ...state,
        idFilteredProducts: idFilteredProducts,
        categories: categories,
        categoriesLoaded: true
      });
    })
    // getProducts().then((catalogue) => {
    //   setState({
    //     ...state,
    //     catalogue: catalogue,
    //     totalItems: catalogue.length,
    //     pages: Math.ceil(catalogue.length / 8),
    //     items: catalogue.slice(0, 8),
    //     dataLoaded: true,
    //   });
    // })
    //   .catch(console.log);
  }, [])

  useEffect(async () => {
    if (state.categoriesLoaded) {
      const post = JSON.stringify({
        ListIdCategorieProduit:
          state.idFilteredProducts?.length
            ? state.idFilteredProducts
            : []
      })
      try {
        const catalogue = await getProducts(post);
        const catalogueWithImages = await Promise.all(catalogue.map(async (product) => {
          if (product.idProduit) {
            const prix = await getProduitPrix(product.idProduit);
            product.produitPrix = prix;

            const img = await getCatalogueImage(product.idProduit);
            if (img?.[0]) {
              product.img = `data:image/jpeg;base64,${img[0].image}`;
            }

            const quantiteEnMain = await getQuantiteEnMain(product.idProduit)
            const quantitePanier = await getQuantiteTempByIdProduit(product.idProduit);
            product.quantiteEnMain = quantiteEnMain - quantitePanier;
          }
          return product;
        }));

        setState(prevState => ({
          ...prevState,
          catalogue: catalogueWithImages,
          totalItems: catalogueWithImages.length,
          pages: Math.ceil(catalogueWithImages.length / 8),
          items: catalogueWithImages.slice(0, 8),
          dataLoaded: true
        }));
      } catch (error) {
        // console.log(error);
      }

    }
  }, [state.categoriesLoaded])

  const applyFilter = () => {
    setState({
      ...state,
      items: [],
      dataLoaded: false,
      categoriesLoaded: false
    });

    const idFilteredProducts = [];
    getCategoriesProduitsBoutique().then((categories) => {
      const search = decodeURI(history.location.search);
      // let checkboxes = categories;
      let filts = "";
      if (categories.length)
        categories.forEach(el => {
          if (search.includes(el.description)) {
            idFilteredProducts.push(el.idProduitCategorie);
            el['checked'] = true;
            // if (data.category === "Price Range") filts += value.value + ',';
          } else el['checked'] = false;
        })
      setState({
        ...state,
        idFilteredProducts: idFilteredProducts,
        categories: categories,
        categoriesLoaded: true
      });
    })
  }
  useEffect(async () => {
    try {
      const product = await Promise.all((state.catalogue || []).map(async (product) => {
        if (product.idProduit) {
          const quantiteEnMain = await getQuantiteEnMain(product.idProduit)
          const quantitePanier = await getQuantiteTempByIdProduit(product.idProduit);
          product.quantiteEnMain = quantiteEnMain - quantitePanier;
        }
        return product;
      }));

      setState({
        ...state,
        catalogue: product
      });
    } catch (error) {
      //console.log(error);
    }


  }, [props.shop.cart, forceRefresh]);

  // const applyFilter = (include, prix) => {
  //   searchProducts(include, prix).then((forfaits) => {
  //     if (forfaits?.forfaits)
  //       setState({
  //         ...state,
  //         catalogue: forfaits.forfaits,
  //         totalItems: forfaits.forfaits.length,
  //         pages: Math.ceil(forfaits.forfaits.length / 8),
  //         items: forfaits.forfaits.slice(0, 8),
  //         dataLoaded: true,
  //       });
  //   });
  // }

  const handleClose = () => {
    setState({
      ...state,
      isOpen: false
    });
  };

  const changePage = (page) => {
    setState({
      ...state,
      currentPage: page,
      items: state.catalogue.slice((page - 1) * 8, page * 8)
    })
    window.scrollTo(0, 800)
  }

  const showPagination = state.dataLoaded && !props.showPaginationMinimum && state.catalogue.length > 0
    && (!props.showPaginationMinimum || (state.totalItems != null && state.totalItems >= 8));

  const Page =
    showPagination
      ? <Pagination
        pages={state.pages}
        totalItems={state.totalItems}
        currentTotalItems={state.items.length}
        currentPage={state.currentPage}
        changePage={changePage}
      />
      : null

  return (
    <div className="container-boutique nopadding">
      {/* <div className="container products-grid products-grid--list position-relative grid-toggle"> */}
      <div className="container-boutique products-grid position-relative grid-toggle">
        {selected &&
          <DemanderProduitPrix
            selected={selected}
            setSelected={setSelected}
            isOpen={selected}
            onAddUpdateShoppingCart={props.onAddUpdateShoppingCart}
            handleClose={() => {
              setPopupProduitPrixOpen(false);
              setSelected(null);
            }}
          />}
        <div className="ais-page">

          <FilterLeftPanel
            showByType='boutique'
            totalItems={state.totalItems}
            applyFilter={applyFilter}
            categories={state.categories}
            getProducts={() => {
            }}
          // getProducts={getProducts}
          />

          <FacturePanierPopup
            showByType='boutique'
            handleClose={handleClose}
            isOpen={state.isOpen}
          />

          <div className="ais-block">
            <div className={`${!state.showSortPanel && 'ais-search-header'} desktop-only`}>
              {/* <span className="ais-refine-search-label">Trier les résultats</span> */}
              <div className="ais-sort">
                {/* <span className="ais-sort-label">Sort by</span> */}
                <span className="ais-sort-orders-container">
                  <select className="ais-SortBy-select">
                    <option value="shopify_products">
                      TRIER
                    </option>
                    <option value="shopify_products_price_asc">
                      Price: Low to High
                    </option>
                    <option value="shopify_products_price_desc">
                      Price: High to Low
                    </option>
                    <option value="shopify_products_title_asc">
                      Name: A to Z
                    </option>
                    <option value="shopify_products_title_desc">
                      Name: Z to A
                    </option>
                    <option value="shopify_products_ratings_desc">
                      Customer Rating
                    </option>
                  </select>
                </span>
              </div>

              {/* <div className="ais-sort margin-bill">
                  <span className="ais-sort-label">Sort by</span>
                  <span onClick={() => setState({ isOpen: true })} className="ais-sort-orders-container magin-left-8">
                    <select className="ais-SortBy-select">
                      <option value='OUVRIR FACTURE'>
                        OUVRIR FACTURE
                      </option>
                    </select>
                  </span>
                </div> */ }
              {/* <div className="ais-change-display" id="ais-change-display-override">
                        <div className="ais-change-display-block">
                          <input type="radio" id="algolia-display-block-button" readonly="" checked="" />
                          <label for="algolia-display-block-button" aria-label="Display products as grid">
                            <i><svg width="26" height="28" viewBox="0 0 12 11" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.9375 0C6.77344 0 6.63281 0.0703125 6.53906 0.164062C6.42188 0.28125 6.375 0.421875 6.375 0.5625V4.3125C6.375 4.47656 6.42188 4.61719 6.53906 4.71094C6.63281 4.82812 6.77344 4.875 6.9375 4.875H11.4375C11.5781 4.875 11.7188 4.82812 11.8359 4.71094C11.9297 4.61719 12 4.47656 12 4.3125V0.5625C12 0.421875 11.9297 0.28125 11.8359 0.164062C11.7188 0.0703125 11.5781 0 11.4375 0H6.9375ZM5.0625 0C5.20312 0 5.34375 0.0703125 5.46094 0.164062C5.55469 0.28125 5.625 0.421875 5.625 0.5625V4.3125C5.625 4.47656 5.55469 4.61719 5.46094 4.71094C5.34375 4.82812 5.20312 4.875 5.0625 4.875H0.5625C0.398438 4.875 0.257812 4.82812 0.164062 4.71094C0.046875 4.61719 0 4.47656 0 4.3125V0.5625C0 0.421875 0.046875 0.28125 0.164062 0.164062C0.257812 0.0703125 0.398438 0 0.5625 0H5.0625ZM0 6.1875C0 6.04688 0.046875 5.90625 0.164062 5.78906C0.257812 5.69531 0.398438 5.625 0.5625 5.625H5.0625C5.20312 5.625 5.34375 5.69531 5.46094 5.78906C5.55469 5.90625 5.625 6.04688 5.625 6.1875V9.9375C5.625 10.1016 5.55469 10.2422 5.46094 10.3359C5.34375 10.4531 5.20312 10.5 5.0625 10.5H0.5625C0.398438 10.5 0.257812 10.4531 0.164062 10.3359C0.046875 10.2422 0 10.1016 0 9.9375V6.1875ZM6.9375 10.5C6.77344 10.5 6.63281 10.4531 6.53906 10.3359C6.42188 10.2422 6.375 10.1016 6.375 9.9375V6.1875C6.375 6.04688 6.42188 5.90625 6.53906 5.78906C6.63281 5.69531 6.77344 5.625 6.9375 5.625H11.4375C11.5781 5.625 11.7188 5.69531 11.8359 5.78906C11.9297 5.90625 12 6.04688 12 6.1875V9.9375C12 10.1016 11.9297 10.2422 11.8359 10.3359C11.7188 10.4531 11.5781 10.5 11.4375 10.5H6.9375Z"></path>
                            </svg></i>
                          </label>
                        </div>
                        <div className="ais-change-display-list">
                          <input type="radio" id="algolia-display-list-button" readonly="" />
                          <label for="algolia-display-list-button" aria-label="Display products as list"><i>
                            <svg width="26" height="28" viewBox="0 0 12 11" xmlns="http://www.w3.org/2000/svg"><path d="M3.49219 4.5625C3.49219 4.42188 3.42188 4.28125 3.32812 4.16406C3.21094 4.07031 3.07031 4 2.92969 4H0.5625C0.398438 4 0.257812 4.07031 0.164062 4.16406C0.046875 4.28125 0 4.42188 0 4.5625V6.4375C0 6.60156 0.046875 6.74219 0.164062 6.83594C0.257812 6.95312 0.398438 7 0.5625 7H2.92969C3.07031 7 3.21094 6.95312 3.32812 6.83594C3.42188 6.74219 3.49219 6.60156 3.49219 6.4375V4.5625ZM0 8.3125C0 8.17188 0.046875 8.03125 0.164062 7.91406C0.257812 7.82031 0.398438 7.75 0.5625 7.75H2.92969C3.07031 7.75 3.21094 7.82031 3.32812 7.91406C3.42188 8.03125 3.49219 8.17188 3.49219 8.3125V10.1875C3.49219 10.3516 3.42188 10.4922 3.32812 10.5859C3.21094 10.7031 3.07031 10.75 2.92969 10.75H0.5625C0.398438 10.75 0.257812 10.7031 0.164062 10.5859C0.046875 10.4922 0 10.3516 0 10.1875V8.3125ZM2.92969 0.25C3.07031 0.25 3.21094 0.320312 3.32812 0.414062C3.42188 0.53125 3.49219 0.671875 3.49219 0.8125V2.6875C3.49219 2.85156 3.42188 2.99219 3.32812 3.08594C3.21094 3.20312 3.07031 3.25 2.92969 3.25H0.5625C0.398438 3.25 0.257812 3.20312 0.164062 3.08594C0.046875 2.99219 0 2.85156 0 2.6875V0.8125C0 0.671875 0.046875 0.53125 0.164062 0.414062C0.257812 0.320312 0.398438 0.25 0.5625 0.25H2.92969ZM4.80469 10.75C4.64062 10.75 4.5 10.7031 4.40625 10.5859C4.28906 10.4922 4.24219 10.3516 4.24219 10.1875V8.3125C4.24219 8.17188 4.28906 8.03125 4.40625 7.91406C4.5 7.82031 4.64062 7.75 4.80469 7.75H11.4375C11.5781 7.75 11.7188 7.82031 11.8359 7.91406C11.9297 8.03125 12 8.17188 12 8.3125V10.1875C12 10.3516 11.9297 10.4922 11.8359 10.5859C11.7188 10.7031 11.5781 10.75 11.4375 10.75H4.80469ZM4.24219 0.8125C4.24219 0.671875 4.28906 0.53125 4.40625 0.414062C4.5 0.320312 4.64062 0.25 4.80469 0.25H11.4375C11.5781 0.25 11.7188 0.320312 11.8359 0.414062C11.9297 0.53125 12 0.671875 12 0.8125V2.6875C12 2.85156 11.9297 2.99219 11.8359 3.08594C11.7188 3.20312 11.5781 3.25 11.4375 3.25H4.80469C4.64062 3.25 4.5 3.20312 4.40625 3.08594C4.28906 2.99219 4.24219 2.85156 4.24219 2.6875V0.8125ZM4.80469 7C4.64062 7 4.5 6.95312 4.40625 6.83594C4.28906 6.74219 4.24219 6.60156 4.24219 6.4375V4.5625C4.24219 4.42188 4.28906 4.28125 4.40625 4.16406C4.5 4.07031 4.64062 4 4.80469 4H11.4375C11.5781 4 11.7188 4.07031 11.8359 4.16406C11.9297 4.28125 12 4.42188 12 4.5625V6.4375C12 6.60156 11.9297 6.74219 11.8359 6.83594C11.7188 6.95312 11.5781 7 11.4375 7H4.80469Z"></path>
                            </svg>
                          </i>
                          </label>
                        </div>
                      </div> */ }
            </div>
            {Page}
            <div className="ais-results-as-block">
              <div className="ais-hits">
                {state.items.length
                  ? state.items.map((card, index) => (
                    <BoutiqueCard
                      key={index}
                      // showPriceAndAddToCart={this.props.showPriceAndAddToCart}
                      showSmallCardTitle={props.showSmallCardTitle}
                      onClick={props.onClick}
                      openPopup={() => {
                        setPopupProduitPrixOpen(true)
                      }}
                      card={card}
                      setSelected={setSelected}
                      onAddUpdateShoppingCart={props.onAddUpdateShoppingCart}
                      refresh={() => setForceRefresh(prev => !prev)}
                    />
                  ))
                  : <span className="boutique-page-no-result">
                    {state.dataLoaded
                      ? <h2>AUCUN RÉSULTAT TROUVÉ</h2>
                      : <h2><LoadingSvg background={props.backgroundSvgColor} /> CHARGEMENT DES DONNÉES…</h2>
                    }
                  </span>
                }
              </div>
            </div>
            {Page}
          </div>
        </div>
      </div>
    </div>
  )
}

BoutiquePage.defaultProps = {
  backgroundSvgColor: "rgb(255, 255, 255)"
}
const mapStateToProps = (state, ownProps) => ({
  shop: state.shop,
  entrepriseName: state.entreprise.nom
});
export default connect(mapStateToProps)(BoutiquePage);